/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pol_Scenario_D_DescInputs */

const en_pol_scenario_d_desc = /** @type {(inputs: Pol_Scenario_D_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep's own key, paid from the Bystep step allowance.`)
};

const id_pol_scenario_d_desc = /** @type {(inputs: Pol_Scenario_D_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunci milik Bystep, dibayar dari jatah langkah Bystep.`)
};

/**
* | output |
* | --- |
* | "Bystep's own key, paid from the Bystep step allowance." |
*
* @param {Pol_Scenario_D_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_scenario_d_desc = /** @type {((inputs?: Pol_Scenario_D_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_Scenario_D_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_scenario_d_desc(inputs)
	return en_pol_scenario_d_desc(inputs)
});